import { render } from "./FormSurveyHeader.vue?vue&type=template&id=483de7ee&scoped=true"
import script from "./FormSurveyHeader.vue?vue&type=script&lang=js"
export * from "./FormSurveyHeader.vue?vue&type=script&lang=js"

import "./FormSurveyHeader.vue?vue&type=style&index=0&id=483de7ee&scoped=true&lang=css"

import exportComponent from "/Users/rs/Development/alisops/aclu-sdic-ice-form/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483de7ee"]])

export default __exports__